<template>
  <v-app>
    <v-row class="px-4">
      <v-col cols="12">
        <v-card elevation="0" style="margin-top: 15px">
          <v-card-title>
            <v-row>
              <v-col class="auto" v-if="mod_name != null">
                {{ $t("_module_expert_") }} : {{ $t(mod_name) }}
              </v-col>

              <v-col class="col-3">
                <tree-select
                  v-model="pdm_values"
                  :auto-load-root-options="true"
                  :defaultExpandLevel="expand_level"
                  :disable-branch-nodes="true"
                  :load-options="getAllPdmTree"
                  :multiple="false"
                  :options="pdm_options"
                  :showCount="true"
                  :placeholder="$t('_selectionner_un_point_de_mesure_')"
                  v-on:input="changePdm(pdm_values)"
                >
                  <div slot="value-label" slot-scope="{ node }">
                    {{ node.raw.customLabel }}
                  </div>
                </tree-select>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>

        <v-card elevation="0" v-if="showGallery">
          <v-card-text>
            <v-row>
              <v-col
                v-for="url in sourceImageURLs"
                :key="url"
                class="d-flex child-flex"
                cols="2"
              >
                <div>
                  <v-row>
                    <v-img
                      :src="url"
                      :lazy-src="url"
                      aspect-ratio="1"
                      cover
                      class="bg-grey-lighten-2"
                      width="200px"
                      @click="showImage(url)"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey-lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-row>
                  <v-row>
                    <v-btn @click="downloadImage(url)">{{
                      $t("_telecharger_le_tableau_comparatif_")
                    }}</v-btn>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import api from "@/api/api";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import Vue from "vue";

Vue.use(VueViewer);

export default {
  components: {
    TreeSelect,
  },
  props: {
    moduleName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,

      // Params
      installation_id: this.$route.params.id,

      // Graphic
      expand_level: 0,

      current_mod: "",
      mod_values: null,
      mod_options: [],

      mod_name: null,

      pdm_values: null,
      pdm_options: [],

      sourceImageURLs: [],
    };
  },

  mounted() {
    this.refreshPage();
    this.getAllPdmTree();
  },

  computed: {
    installation() {
      return this.$store.getters.installations.find(
        (x) => x.id == this.installation_id
      );
    },

    showGallery() {
      return this.pdm_values !== undefined && this.pdm_values !== null;
    },
  },

  watch: {
    $route: {
      async handler() {
        this.refreshPage();
        this.installation_id = this.$route.params.id;

        await this.getAllPdmTree();
      },
      immediate: true,
    },

    "$root.$i18n.locale"() {
      this.refreshPage();
    },
  },

  methods: {
    getCurrentModule() {
      return this.$route.params.expert || this.moduleName;
    },

    downloadImage(url) {
      let link = document.createElement("a");
      link.download =
        this.$t(this.mod_name) +
        "_" +
        this.$route.params.id +
        "_" +
        this.pdm_values +
        ".png";
      link.href = url;
      link.click();
    },
    refreshPage() {
      switch (this.$route.params.expert) {
        case "bypass":
          this.mod_name = this.$t("_diodes_bypass_");
          break;
        case "disconnect":
          this.mod_name = this.$t("_deconnexion_chaines_");
          break;
        case "mask":
          this.mod_name = this.$t("_masque_");
          break;
        case "layout_guess":
          this.mod_name = this.$t("_layout_guess_");
          break;
        case "alarms":
          this.mod_name = this.$t("_historique_alarmes_");
          break;
        default:
          this.mod_name = "-";
      }
    },

    getImageUrls(pdm) {
      const img_pdm = this.pdm_options.find((x) => x.id === pdm);
      return img_pdm["img_list"];
    },

    async getAllPdmTree() {
      const langcode = this.$root.$i18n.locale;
      this.current_mod = this.getCurrentModule();
      const res = await api.getExpertModTreePic(
        this.installation.repo_id,
        this.current_mod,
        langcode
      );

      this.pdm_options = res.data.tree || [];
      this.expand_level = res.data.expand_level || 0;
      if (this.expand_level === 1) {
        const pacgrid = this.findPdmById(this.pdm_options, "site");

        if (pacgrid) {
          this.pdm_values = pacgrid.id;
          await this.changePdm(this.pdm_values);
        }
      }
    },

    findPdmById(nodes, targetId) {
      for (const node of nodes) {
        if (node.id === targetId) {
          return node;
        }

        if (node.children && node.children.length) {
          const found = this.findPdmById(node.children, targetId);

          if (found) {
            return found;
          }
        }
      }

      return null;
    },
    async getFileImage(repoId, img) {
      await api
        // .getFileRepository(repoId, 'image_expert_module', img.replace(/^.*[\\/]/, ''), 'image/png')
        .getFileRepository(repoId, "image_expert_module", img, "image/png")
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          this.sourceImageURLs.push(url);
          return url;
        })
        .catch(console.error);
    },

    async changePdm(pdm) {
      if (pdm !== undefined && pdm !== null) {
        const repoId = this.installation.repo_id;

        this.sourceImageURLs = [];
        let imgUrls = [...this.getImageUrls(pdm)];

        for (let idx = 0; idx < imgUrls.length; idx++) {
          await this.getFileImage(repoId, imgUrls[idx]);
        }
      }
    },

    showImage(url) {
      const idxImage = this.sourceImageURLs.indexOf(url);

      this.$viewerApi({
        options: {
          inline: true,
          button: true,
          navbar: false,
          title: false,
          toolbar: true,
          tooltip: true,
          movable: true,
          zoomable: true,
          rotatable: false,
          scalable: false,
          transition: true,
          fullscreen: true,
          keyboard: true,
          initialViewIndex: idxImage,
        },
        images: this.sourceImageURLs,
      });
    },
  },
};
</script>

<style scoped>
.v-select-like {
  border: 1px solid black !important;
  width: 100%;
  display: block;
  border-radius: 4px;
  outline: none;
  color: black;
}

.vue-treeselect {
  font-size: 0.9rem;
  font-weight: normal;
}

.v-card__subtitle,
.v-card__title {
  padding: 16px;
  border-bottom: #eee solid 1px;
}

.v-image__image.on-hover,
.v-image__placeholder.on-hover {
  border: #000 solid 1px;
}
</style>
